import { paymentSchema } from '../schemas/order/paymentSchema';

export const paymentsStripe = paymentSchema
  .pick({
    paymentType: true,
    status: true,
    paymentGateway: true,
    last4: true,
    paymentGatewayAccountId: true,
    paymentGatewayPaymentId: true,
  })
  .decode({
    paymentType: 'CREDIT_CARD',
    status: 'AUTHORIZED',
    paymentGateway: 'STRIPE',
    // `last4` isn't available on the PaymentIntent object and doesn't seem to be available
    // via any Stripe client side API. We instead set this server side.
    last4: null,
    paymentGatewayAccountId: 'acct_test123',
    paymentGatewayPaymentId: 'pi_test123',
  });

export const paymentsWorldline = paymentSchema
  .pick({
    paymentType: true,
    status: true,
    paymentGateway: true,
  })
  .decode({
    paymentType: 'CREDIT_CARD',
    status: 'AUTHORIZED',
    paymentGateway: 'WORLDLINE',
  });
